// ================================================================
// PROPRIETARY & CONFIDENTIAL — Miskulin Technologies Inc.
// Copyright (c) 2026 Miskulin Technologies. All rights reserved.
// ================================================================
import React, { useState } from 'react';
import { useAuth } from '../AuthContext';

const SERVICES = [
  { id: 1, name: 'Initial Consultation', duration: '30 min', price: 'Free', color: '#10b981' },
  { id: 2, name: 'Strategy Session', duration: '60 min', price: '$150', color: '#6366f1' },
  { id: 3, name: 'Full Audit', duration: '90 min', price: '$350', color: '#8b5cf6' },
  { id: 4, name: 'Implementation Call', duration: '60 min', price: '$200', color: '#3b82f6' },
  { id: 5, name: 'Follow-up Review', duration: '30 min', price: '$75', color: '#f59e0b' },
];

const HOURS = ['9:00 AM', '9:30 AM', '10:00 AM', '10:30 AM', '11:00 AM', '11:30 AM', '1:00 PM', '1:30 PM', '2:00 PM', '2:30 PM', '3:00 PM', '3:30 PM', '4:00 PM', '4:30 PM'];

const DEMO_BOOKINGS = [
  { id: 1, client: 'Sarah Mitchell', email: 'sarah@techcorp.ca', service: 'Strategy Session', date: 'Feb 21, 2026', time: '10:00 AM', status: 'Confirmed', phone: '(403) 555-0142' },
  { id: 2, client: 'James Rodriguez', email: 'james@buildit.ca', service: 'Initial Consultation', date: 'Feb 22, 2026', time: '2:00 PM', status: 'Pending', phone: '(587) 555-0198' },
  { id: 3, client: 'Emily Chen', email: 'echen@greenfield.ca', service: 'Full Audit', date: 'Feb 24, 2026', time: '11:00 AM', status: 'Confirmed', phone: '(403) 555-0231' },
  { id: 4, client: 'Mike Thompson', email: 'mike@westcoast.ca', service: 'Follow-up Review', date: 'Feb 25, 2026', time: '3:30 PM', status: 'Pending', phone: '(250) 555-0177' },
];

const WEEKDAYS = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

function BookingPage() {
  const { user } = useAuth();
  const [tab, setTab] = useState('bookings');
  const [selectedSlot, setSelectedSlot] = useState(null);

  const renderBookings = () => (
    <div>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: 16, marginBottom: 24 }}>
        {[{ l: 'Upcoming', v: DEMO_BOOKINGS.length.toString(), c: '#6366f1' }, { l: 'Confirmed', v: DEMO_BOOKINGS.filter(b => b.status === 'Confirmed').length.toString(), c: '#10b981' }, { l: 'Pending', v: DEMO_BOOKINGS.filter(b => b.status === 'Pending').length.toString(), c: '#f59e0b' }, { l: 'This Week Revenue', v: '$575', c: '#3b82f6' }].map(s => (
          <div key={s.l} style={{ background: 'var(--card)', border: '1px solid var(--border)', borderRadius: 12, padding: 20 }}>
            <p style={{ fontSize: 13, color: 'var(--text-muted)' }}>{s.l}</p><p style={{ fontSize: 28, fontWeight: 700, color: s.c }}>{s.v}</p>
          </div>
        ))}
      </div>
      <div style={{ background: 'var(--card)', border: '1px solid var(--border)', borderRadius: 12, overflow: 'hidden' }}>
        <div style={{ display: 'grid', gridTemplateColumns: '1.5fr 2fr 1.5fr 120px 100px 100px 100px', padding: '12px 20px', background: 'var(--bg)', borderBottom: '1px solid var(--border)', fontSize: 12, fontWeight: 600, color: 'var(--text-muted)', textTransform: 'uppercase' }}>
          <span>Client</span><span>Email</span><span>Service</span><span>Date</span><span>Time</span><span>Status</span><span>Actions</span>
        </div>
        {DEMO_BOOKINGS.map(b => (
          <div key={b.id} style={{ display: 'grid', gridTemplateColumns: '1.5fr 2fr 1.5fr 120px 100px 100px 100px', padding: '14px 20px', borderBottom: '1px solid var(--border)', alignItems: 'center', fontSize: 14 }}>
            <span style={{ fontWeight: 500, color: 'var(--text)' }}>{b.client}</span>
            <span style={{ color: 'var(--text-muted)', fontSize: 13 }}>{b.email}</span>
            <span style={{ color: 'var(--text-muted)' }}>{b.service}</span>
            <span style={{ color: 'var(--text-muted)', fontSize: 13 }}>{b.date}</span>
            <span style={{ color: 'var(--text-muted)', fontSize: 13 }}>{b.time}</span>
            <span style={{ fontSize: 12, fontWeight: 500, color: b.status === 'Confirmed' ? '#10b981' : '#f59e0b' }}>{b.status}</span>
            <div style={{ display: 'flex', gap: 4 }}>
              {b.status === 'Pending' && <button style={{ padding: '4px 10px', background: '#10b981', color: '#fff', border: 'none', borderRadius: 4, fontSize: 11, cursor: 'pointer' }}>Confirm</button>}
              <button style={{ padding: '4px 10px', background: 'transparent', color: '#ef4444', border: '1px solid #ef4444', borderRadius: 4, fontSize: 11, cursor: 'pointer' }}>Cancel</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );

  const renderCalendar = () => (
    <div>
      <h2 style={{ fontSize: 20, fontWeight: 600, color: 'var(--text)', marginBottom: 16 }}>Weekly Schedule</h2>
      <div style={{ background: 'var(--card)', border: '1px solid var(--border)', borderRadius: 12, overflow: 'hidden' }}>
        <div style={{ display: 'grid', gridTemplateColumns: '80px repeat(7, 1fr)', background: 'var(--bg)', borderBottom: '1px solid var(--border)' }}>
          <div style={{ padding: 10 }} />
          {WEEKDAYS.map(d => (<div key={d} style={{ padding: 10, textAlign: 'center', fontSize: 13, fontWeight: 600, color: 'var(--text-muted)' }}>{d}</div>))}
        </div>
        {HOURS.filter((_, i) => i % 2 === 0).map(hour => (
          <div key={hour} style={{ display: 'grid', gridTemplateColumns: '80px repeat(7, 1fr)', borderBottom: '1px solid var(--border)' }}>
            <div style={{ padding: '8px 10px', fontSize: 12, color: 'var(--text-muted)', borderRight: '1px solid var(--border)' }}>{hour}</div>
            {WEEKDAYS.map(day => {
              const booking = DEMO_BOOKINGS.find(b => b.time === hour);
              return (
                <div key={day} onClick={() => setSelectedSlot(`${day} ${hour}`)} style={{ padding: 6, minHeight: 40, borderRight: '1px solid var(--border)', cursor: 'pointer', background: selectedSlot === `${day} ${hour}` ? 'rgba(99,102,241,0.06)' : 'transparent' }}>
                  {booking && day === 'Fri' && (
                    <div style={{ background: 'rgba(99,102,241,0.1)', borderRadius: 4, padding: '4px 6px', fontSize: 11, color: '#6366f1' }}>{booking.client.split(' ')[0]}</div>
                  )}
                </div>
              );
            })}
          </div>
        ))}
      </div>
    </div>
  );

  const renderServices = () => (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
        <h2 style={{ fontSize: 20, fontWeight: 600, color: 'var(--text)' }}>Services</h2>
        <button style={{ padding: '8px 16px', background: '#6366f1', color: '#fff', border: 'none', borderRadius: 8, fontSize: 13, fontWeight: 500, cursor: 'pointer' }}>+ Add Service</button>
      </div>
      <div style={{ display: 'grid', gap: 10 }}>
        {SERVICES.map(s => (
          <div key={s.id} style={{ background: 'var(--card)', border: '1px solid var(--border)', borderRadius: 10, padding: 16, display: 'flex', alignItems: 'center', gap: 16, borderLeft: `4px solid ${s.color}` }}>
            <div style={{ flex: 1 }}>
              <h4 style={{ fontSize: 15, fontWeight: 600, color: 'var(--text)', marginBottom: 4 }}>{s.name}</h4>
              <p style={{ fontSize: 13, color: 'var(--text-muted)' }}>{s.duration}</p>
            </div>
            <span style={{ fontSize: 18, fontWeight: 700, color: s.color }}>{s.price}</span>
            <button style={{ padding: '6px 12px', background: 'transparent', color: '#6366f1', border: '1px solid #6366f1', borderRadius: 6, fontSize: 12, cursor: 'pointer' }}>Edit</button>
          </div>
        ))}
      </div>
    </div>
  );

  const renderSettings = () => (
    <div style={{ background: 'var(--card)', border: '1px solid var(--border)', borderRadius: 12, padding: 24 }}>
      <h2 style={{ fontSize: 20, fontWeight: 600, color: 'var(--text)', marginBottom: 20 }}>Booking Settings</h2>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16, marginBottom: 20 }}>
        <div><label style={labelStyle}>Business Hours Start</label><input type="time" defaultValue="09:00" style={inputStyle} /></div>
        <div><label style={labelStyle}>Business Hours End</label><input type="time" defaultValue="17:00" style={inputStyle} /></div>
        <div><label style={labelStyle}>Buffer Between Bookings</label><select style={inputStyle}><option>15 minutes</option><option>30 minutes</option><option>None</option></select></div>
        <div><label style={labelStyle}>Advance Booking Window</label><select style={inputStyle}><option>2 weeks</option><option>1 month</option><option>3 months</option></select></div>
      </div>
      <div style={{ marginBottom: 20 }}>
        <label style={labelStyle}>Cancellation Policy</label>
        <textarea rows={3} style={{ ...inputStyle, resize: 'vertical' }} defaultValue="Cancellations must be made at least 24 hours in advance. Late cancellations may be subject to a fee." />
      </div>
      <div style={{ marginBottom: 20, padding: 16, background: 'var(--bg)', borderRadius: 8, border: '1px solid var(--border)' }}>
        <h3 style={{ fontSize: 14, fontWeight: 600, color: 'var(--text)', marginBottom: 8 }}>Embed Widget</h3>
        <p style={{ fontSize: 13, color: 'var(--text-muted)', marginBottom: 8 }}>Add this code to your website to embed the booking widget.</p>
        <code style={{ display: 'block', padding: 12, background: 'var(--card)', borderRadius: 6, fontSize: 12, color: '#6366f1', wordBreak: 'break-all' }}>
          {'<script src="https://forge.pages.dev/booking-widget.js" data-business="your-id"></script>'}
        </code>
      </div>
      <button style={{ padding: '10px 24px', background: '#6366f1', color: '#fff', border: 'none', borderRadius: 8, fontSize: 14, fontWeight: 500, cursor: 'pointer' }}>Save Settings</button>
    </div>
  );

  return (
    <div style={{ padding: '24px 32px', maxWidth: 1200, margin: '0 auto' }}>
      <div style={{ marginBottom: 28 }}>
        <h1 style={{ fontSize: 28, fontWeight: 700, color: 'var(--text)', marginBottom: 6 }}>{'\uD83D\uDCC5'} Booking & Scheduling</h1>
        <p style={{ color: 'var(--text-muted)', fontSize: 15 }}>Online booking system that embeds directly into your website.</p>
      </div>
      <div style={{ display: 'flex', gap: 8, marginBottom: 24 }}>
        {['bookings', 'calendar', 'services', 'settings'].map(t => (
          <button key={t} onClick={() => setTab(t)} style={{ padding: '8px 20px', background: tab === t ? '#6366f1' : 'var(--card)', color: tab === t ? '#fff' : 'var(--text-muted)', border: tab === t ? 'none' : '1px solid var(--border)', borderRadius: 8, fontSize: 14, fontWeight: 500, cursor: 'pointer', textTransform: 'capitalize' }}>{t}</button>
        ))}
      </div>
      {tab === 'bookings' && renderBookings()}
      {tab === 'calendar' && renderCalendar()}
      {tab === 'services' && renderServices()}
      {tab === 'settings' && renderSettings()}
    </div>
  );
}

const labelStyle = { display: 'block', fontSize: 13, fontWeight: 600, color: 'var(--text-muted)', marginBottom: 6 };
const inputStyle = { width: '100%', padding: '10px 14px', background: 'var(--bg)', border: '1px solid var(--border)', borderRadius: 8, color: 'var(--text)', fontSize: 14, outline: 'none', boxSizing: 'border-box' };

export default BookingPage;
